import React, { useState, useEffect, useCallback } from 'react';
import { RedSwitch } from 'components/utility/Switches';
import { toggleRead } from 'reducers/slices/readstatus';
import { setLanguageSettings } from 'reducers/slices/languagesettings';
import { SizableText, XStack, useTheme } from 'tamagui';
import { Center } from 'components/base/General';
import { useDispatch, useSelector } from 'react-redux';
import { debounce } from 'lodash';

export const ReadSwitch = () => {
  const dispatch = useDispatch();
  // Replace settings with languagesettings slice
  const languagesettings = useSelector((state) => state.languagesettings);
  const { showRead: reduxShowRead } = languagesettings;
  const theme = useTheme();

  // Local state
  const [localShowRead, setLocalShowRead] = useState(reduxShowRead);

  // Update local state when Redux state changes
  useEffect(() => {
    setLocalShowRead(reduxShowRead);
  }, [reduxShowRead]);

  // Debounced function to update Redux state
  const debouncedUpdateRedux = useCallback(
    debounce((value) => {
      dispatch(setLanguageSettings({ showRead: value }));
      dispatch(toggleRead(false));
    }, 300),
    [dispatch]
  );

  const toggleReadSwitch = () => {
    const updatedShowRead = !localShowRead;
    setLocalShowRead(updatedShowRead);
    debouncedUpdateRedux(updatedShowRead);
  };

  return (
    <Center>
      <XStack
        minWidth={350}
        maxWidth={350}
        maxHeight={150}
        p={20}
        justifyContent="space-between"
        alignItems="center"
      >
        <SizableText
          color={theme.mainColor.get()}
          fontWeight="bold"
          fontSize={16}
        >
          Show Previously Read Articles
        </SizableText>
        <RedSwitch toggle={toggleReadSwitch} checked={localShowRead} />
      </XStack>
    </Center>
  );
};
